// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"71476d4a","455":"4167b5b5","977":"4dc61a07"}[chunkId] + ".chunk.js";
};